import { NgModule } from '@angular/core';;
import { CommonModule } from '@angular/common';
import { GuageComponent } from './pipeline-leaderboard/guage/guage.component';
import { TimelinechartComponent } from './pipeline-leaderboard/timelinechart/timelinechart.component';
import { GaugeModule } from 'angular-gauge';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { ScreenComponent } from './pipeline-leaderboard/screen/screen.component';
import { PipelineLeaderboardComponent } from './pipeline-leaderboard/pipeline-leaderboard.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    PipelineLeaderboardComponent,
    GuageComponent,
    TimelinechartComponent,
    ScreenComponent
  ],
  imports: [
    CommonModule,
    GaugeModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    NgSelectModule,
  ],
  exports: [
    PipelineLeaderboardComponent
  ]
})
export class PipelineLeaderboardModule { }
